<template>
    <div>
        <component :is="layout" v-if="authChecked">
            <router-view />
        </component>
        <div style="height: 100vh" class="w-100 flex-column d-flex justify-content-center align-items-center" v-else>
            <div class="spinner-border m-3"></div>
            <strong>Please wait...</strong>
        </div>
        <notifications />
    </div>
</template>

<script>

import DashboardService from "@/services/dashboard.service";
window.baseUrl = 'http://123.200.20.18:5503';
export default {
    name: 'App',
    computed: {
        layout() {
            return (this.$route.meta.layout || 'div')
        },
        authChecked() {
            return this.$store.state.auth.checked;
        },
    },
    methods: {
        logOut() {
            this.$store.dispatch('auth/logout');
            this.$router.push('/');
        }
    },
    created() {
        const user = JSON.parse(localStorage.getItem('user'));
        if (user) {
            DashboardService.getUserInfo().then(() => {
                // Check for pending ACS.
                /*this.$store.dispatch('acs/checkPendingTrans');*/
                setTimeout(() => this.$store.dispatch('auth/checked'), this.$route.path !== '/' ? 300 : 0)
            }).catch(() => {
                // DO NOTHING.
                localStorage.clear();
                setTimeout(() => this.$store.dispatch('auth/checked'), this.$route.path !== '/' ? 300 : 0)
            }).finally(() => {
            })
        } else {
            setTimeout(() => this.$store.dispatch('auth/checked'), this.$route.path !== '/' ? 300 : 0)
        }
    },
}
</script>
